module.exports = __webpack_public_path__ + "static/05-3-9aa7a21d663ffe5067f6e708bee5254a.jpg";